import { render, staticRenderFns } from "./WebsiteCompliance.vue?vue&type=template&id=4b4b8204&scoped=true"
import script from "./WebsiteCompliance.vue?vue&type=script&lang=js"
export * from "./WebsiteCompliance.vue?vue&type=script&lang=js"
import style0 from "./WebsiteCompliance.vue?vue&type=style&index=0&id=4b4b8204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b8204",
  null
  
)

export default component.exports